// name alpha sort
export const oemsColumnMeta = {
    CommittedAmtBookCurrency: {
        key: "CommittedAmtBookCurrency",
        name: "$ Committed Amount",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Order",
    },
    NotionalFilledAmountBookCurrency: {
        key: "NotionalFilledAmountBookCurrency",
        name: "$ Notional Filled Amount",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    NotionalFilledAmountAvgPxBookCurrency: {
        key: "NotionalFilledAmountAvgPxBookCurrency",
        name: "$ Notional Filled Amt - Avg Px",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    NotionalTradeAmountBookCurrency: {
        key: "NotionalTradeAmountBookCurrency",
        name: "$ Notional Trade Amount",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    NotionalUnfilledAmountBookCurrency: {
        key: "NotionalUnfilledAmountBookCurrency",
        name: "$ Notional Unfilled Amount",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    SODNotionalTradeAmtBookCcy: {
        key: "SODNotionalTradeAmtBookCcy",
        name: "$ SOD Notional Trade Amount (Global)",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    TodayNotionalFilledAmtBookCcy: {
        key: "TodayNotionalFilledAmtBookCcy",
        name: "$ Today Notional Filled Amount (Global)",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    _20DAvgVol: {
        key: "_20DAvgVol",
        name: "20D Avg Vol",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    _30DAvgVol: {
        key: "_30DAvgVol",
        name: "30D Avg Vol",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    _3MAvgVol: {
        key: "_3MAvgVol",
        name: "3M Avg Vol",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    _5DAvgVol: {
        key: "_5DAvgVol",
        name: "5D Avg Vol",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    AccountNumber: {
        key: "AccountNumber",
        name: "Account Number",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Allocations",
    },
    _Control_: {
        key: "_Control_",
        name: "Actions",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    AllocationInstructions: {
        key: "AllocationInstructions",
        name: "Alloc Instr",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Allocations",
    },
    AllocationReason: {
        key: "AllocationReason",
        name: "Allocation Reason",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    ShortLocateAmountApproved: {
        key: "ShortLocateAmountApproved",
        name: "Apr SL Qty",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Order",
    },
    ArrivalPctChange: {
        key: "ArrivalPctChange",
        name: "Arrival % Change",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Order",
    },
    ArrivalPrice: {
        key: "ArrivalPrice",
        name: "Arrival Price",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Order",
    },
    ArrivalVWAP: {
        key: "ArrivalVWAP",
        name: "Arrival VWAP",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Order",
    },
    Ask: {
        key: "Ask",
        name: "Ask",
        columnTypeCategory: "Quotation",
        sideSensitive: false,
        category: "Related Market Data",
    },
    AssignedCpty: {
        key: "AssignedCpty",
        name: "Assigned Cpty",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    AssignedSLID: {
        key: "AssignedSLID",
        name: "Assigned SL ID",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    ShortLocateAmountAssigned: {
        key: "ShortLocateAmountAssigned",
        name: "Assigned SL Qty",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Order",
    },
    AvgPx: {
        key: "AvgPx",
        name: "Avg Px",
        columnTypeCategory: "AveragePrice",
        sideSensitive: false,
        category: "Fill Info",
    },
    BBFutureRoot: {
        key: "BBFutureRoot",
        name: "BB Future Root",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    BBTicker: {
        key: "BBTicker",
        name: "BB Ticker",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    Bid: {
        key: "Bid",
        name: "Bid",
        columnTypeCategory: "Quotation",
        sideSensitive: false,
        category: "Related Market Data",
    },
    BidAskDelta: {
        key: "BidAskDelta",
        name: "Bid/Ask Delta",
        columnTypeCategory: "SignSensitiveNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    BilateralCleared: {
        key: "BilateralCleared",
        name: "Bilateral/Cleared",
        columnTypeCategory: "Enum",
        sideSensitive: false,
        category: "Order",
    },
    BookCS01: {
        key: "BookCS01",
        name: "Book CS01",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Order",
    },
    BookDV01: {
        key: "BookDV01",
        name: "Book DV01",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Order",
    },
    BookName: {
        key: "BookName",
        name: "Book Name",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Allocations",
    },
    Broker: {
        key: "Broker",
        name: "Broker",
        columnTypeCategory: "Standard",
        sideSensitive: true,
        category: "Execution Route",
    },
    BrokerAccount: {
        key: "BrokerAccount",
        name: "Broker Account",
        columnTypeCategory: "Standard",
        sideSensitive: true,
        category: "Execution Route",
    },
    CCP: {
        key: "CCP",
        name: "CCP",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    CalculatorType: {
        key: "CalculatorType",
        name: "Calculator Type",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    Cap: {
        key: "Cap",
        name: "Cap?",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Security Master",
    },
    Ccy: {
        key: "Ccy",
        name: "Ccy",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    Change: {
        key: "Change",
        name: "Change",
        columnTypeCategory: "SignSensitiveNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    ChangePct: {
        key: "ChangePct",
        name: "Change(%)",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    ChangesToAcknowledge: {
        key: "ChangesToAcknowledge",
        name: "Changes to Ack",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    ClearingAccount: {
        key: "ClearingAccount",
        name: "Clearing Account",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Allocations",
    },
    CommissionRate: {
        key: "CommissionRate",
        name: "Comm Rate",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    CommissionRateType: {
        key: "CommissionRateType",
        name: "Comm Rate Type",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Proceeds",
    },
    CommissionTotal: {
        key: "CommissionTotal",
        name: "Comm Total",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    Committed: {
        key: "Committed",
        name: "Committed",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Order",
    },
    CommittedPct: {
        key: "CommittedPct",
        name: "Committed %",
        columnTypeCategory: "PercentFilled",
        sideSensitive: false,
        category: "Order",
    },
    CommittedAmt: {
        key: "CommittedAmt",
        name: "Committed Amount",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Order",
    },
    completed: {
        key: "completed",
        name: "Completed",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    CompletedDate: {
        key: "CompletedDate",
        name: "Completed Dt",
        columnTypeCategory: "DateTime",
        sideSensitive: false,
        category: "Order",
    },
    CompletionStatus: {
        key: "CompletionStatus",
        name: "Completion Status",
        columnTypeCategory: "Enum",
        sideSensitive: false,
        category: "Order",
    },
    Compliance: {
        key: "Compliance",
        name: "Compliance",
        columnTypeCategory: "Compliance",
        sideSensitive: false,
        category: "Order",
    },
    ComplianceNotes: {
        key: "ComplianceNotes",
        name: "Compliance Notes",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    ContraCcy: {
        key: "ContraCcy",
        name: "Contra Ccy",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    Contract: {
        key: "Contract",
        name: "Contract",
        columnTypeCategory: "Standard",
        sideSensitive: true,
        category: "Security Master",
    },
    ContractSize: {
        key: "ContractSize",
        name: "Contract Size",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Security Master",
    },
    Counterparty: {
        key: "Counterparty",
        name: "Counterparty",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Execution Route",
    },
    CounterpartyMemo: {
        key: "CounterpartyMemo",
        name: "Cpty Memo",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Execution Route",
    },
    CreationDate: {
        key: "CreationDate",
        name: "Creation Date",
        columnTypeCategory: "DateTime",
        sideSensitive: false,
        category: "Order",
    },
    OrderCreationMethod: {
        key: "OrderCreationMethod",
        name: "Creation Method",
        columnTypeCategory: "Enum",
        sideSensitive: false,
        category: "Order",
    },
    CreationPrice: {
        key: "CreationPrice",
        name: "Creation Price",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Order",
    },
    CreditDirection: {
        key: "CreditDirection",
        name: "Credit Direction",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    DayParticipationRate: {
        key: "DayParticipationRate",
        name: "Day Participation Rate",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    DayParticipationShares: {
        key: "DayParticipationShares",
        name: "Day Participation Shares",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    DealId: {
        key: "DealId",
        name: "Deal Id",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Allocations",
    },
    DealSpread: {
        key: "DealSpread",
        name: "Deal Spread",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Order",
    },
    DealTerms: {
        key: "DealTerms",
        name: "Deal Terms",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Program Trading",
    },
    Delta: {
        key: "Delta",
        name: "Delta",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Related Market Data",
    },
    DeltaAdjExposure: {
        key: "DeltaAdjExposure",
        name: "Delta Adjusted Exposure",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Order",
    },
    Destination: {
        key: "Destination",
        name: "Destination",
        columnTypeCategory: "Standard",
        sideSensitive: true,
        category: "Execution Route",
    },
    EffectiveDate: {
        key: "EffectiveDate",
        name: "Effective Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Security Master",
    },
    Proceeds: {
        key: "Proceeds",
        name: "Estimated Proceeds",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    ExchangeCountryCode: {
        key: "ExchangeCountryCode",
        name: "Exch Country Code",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    ExchangeCountryName: {
        key: "ExchangeCountryName",
        name: "Exch Country Name",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    Exchange: {
        key: "Exchange",
        name: "Exchange",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    ExchangeMIC: {
        key: "ExchangeMIC",
        name: "Exchange MIC Code",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    ExecVal_NAV: {
        key: "ExecVal_NAV",
        name: "Exec Val / NAV",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Proceeds",
    },
    ExecutedExposureBPS: {
        key: "ExecutedExposureBPS",
        name: "Executed Exposure (BPS)",
        columnTypeCategory: "SignSensitiveNumber",
        sideSensitive: false,
        category: "Order",
    },
    Exposure: {
        key: "Exposure",
        name: "Exposure",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Position",
    },
    ExposureChange: {
        key: "ExposureChange",
        name: "Exposure Change",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Position",
    },
    FCM: {
        key: "FCM",
        name: "FCM",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    FIXOrderId: {
        key: "FIXOrderId",
        name: "FIX Order Id",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Execution Route",
    },
    SettleToBookFXRate: {
        key: "SettleToBookFXRate",
        name: "FX Rate",
        columnTypeCategory: "Quotation",
        sideSensitive: false,
        category: "Related Market Data",
    },
    FarAmount: {
        key: "FarAmount",
        name: "Far Amount",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Order",
    },
    FXFarFixingDate: {
        key: "FXFarFixingDate",
        name: "Far Fixing Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Security Master",
    },
    FXFarForwardDate: {
        key: "FXFarForwardDate",
        name: "Far Forward Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Security Master",
    },
    FillPriceDeviation: {
        key: "FillPriceDeviation",
        name: "Fill Px % Deviation",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    Filled: {
        key: "Filled",
        name: "Filled",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Fill Info",
    },
    FilledPctOf30D_ADV: {
        key: "FilledPctOf30D_ADV",
        name: "Filled  % of 30D ADV",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    FilledPct: {
        key: "FilledPct",
        name: "Filled %",
        columnTypeCategory: "PercentFilled",
        sideSensitive: false,
        category: "Fill Info",
    },
    FilledPctOf3M_ADV: {
        key: "FilledPctOf3M_ADV",
        name: "Filled % of 3M ADV",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    FirstCounterparty: {
        key: "FirstCounterparty",
        name: "First Counterparty",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    FirstFilledDate: {
        key: "FirstFilledDate",
        name: "First Filled Dt",
        columnTypeCategory: "DateTime",
        sideSensitive: false,
        category: "Order",
    },
    FirstTransmittedDate: {
        key: "FirstTransmittedDate",
        name: "First Transmit Dt",
        columnTypeCategory: "DateTime",
        sideSensitive: false,
        category: "Order",
    },
    FixedRate: {
        key: "FixedRate",
        name: "Fixed Rate",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    FXFixingDate: {
        key: "FXFixingDate",
        name: "Fixing Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Security Master",
    },
    ForwardDate: {
        key: "ForwardDate",
        name: "Forward Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Order",
    },
    FullyAdjustedPrevLastPx: {
        key: "FullyAdjustedPrevLastPx",
        name: "Fully Adj Prev Last Px",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Related Market Data",
    },
    FundFullName: {
        key: "FundFullName",
        name: "Fund Full Name",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    FundName: {
        key: "FundName",
        name: "Fund Name",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Allocations",
    },
    GICGroup: {
        key: "GICGroup",
        name: "GIC Group",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    GICIndustry: {
        key: "GICIndustry",
        name: "GIC Industry",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    GICSector: {
        key: "GICSector",
        name: "GIC Sector",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    GICSubIndustry: {
        key: "GICSubIndustry",
        name: "GIC Sub Industry",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    ISIN: {
        key: "ISIN",
        name: "ISIN",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Security Master",
    },
    Idle: {
        key: "Idle",
        name: "Idle",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Order",
    },
    ImpactVWAP: {
        key: "ImpactVWAP",
        name: "Impact VWAP",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Related Market Data",
    },
    FilledPctOfImpactVWAPShares: {
        key: "FilledPctOfImpactVWAPShares",
        name: "Impact VWAP %",
        columnTypeCategory: "Percent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    ImpactVWAPAvgPxDelta: {
        key: "ImpactVWAPAvgPxDelta",
        name: "Impact VWAP / Avg Px Delta",
        columnTypeCategory: "SignSensitiveNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    ImpactVWAPShares: {
        key: "ImpactVWAPShares",
        name: "Impact VWAP Shares",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    Instructions: {
        key: "Instructions",
        name: "Instructions",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    InstrumentId: {
        key: "InstrumentId",
        name: "Instrument Id",
        columnTypeCategory: "IdNumber",
        sideSensitive: false,
        category: "Security Master",
    },
    InstrumentSubtype: {
        key: "InstrumentSubtype",
        name: "Instrument Subtype",
        columnTypeCategory: "Enum",
        sideSensitive: false,
        category: "Security Master",
    },
    InstrumentType: {
        key: "InstrumentType",
        name: "Instrument Type",
        columnTypeCategory: "Enum",
        sideSensitive: false,
        category: "Security Master",
    },
    IsActiveParent: {
        key: "IsActiveParent",
        name: "Is Active Parent",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    IsCurrentlyScheduled: {
        key: "IsCurrentlyScheduled",
        name: "Is Currently Scheduled",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    isExecutionRoute: {
        key: "isExecutionRoute",
        name: "Is Execution Route",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    IsForceCancel: {
        key: "IsForceCancel",
        name: "Is Force Cancel",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    IsStale: {
        key: "IsStale",
        name: "Is Stale",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    Undecided: {
        key: "Undecided",
        name: "Is Undecided",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    IsUnsolicitedCancel: {
        key: "IsUnsolicitedCancel",
        name: "Is Unsolicited Cancel",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    Issuer: {
        key: "Issuer",
        name: "Issuer",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    Last: {
        key: "Last",
        name: "Last",
        columnTypeCategory: "Quotation",
        sideSensitive: false,
        category: "Related Market Data",
    },
    LastFillPx: {
        key: "LastFillPx",
        name: "Last Fill Px",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Fill Info",
    },
    LastFillQty: {
        key: "LastFillQty",
        name: "Last Fill Quantity",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Fill Info",
    },
    LastFilledDate: {
        key: "LastFilledDate",
        name: "Last Filled Dt",
        columnTypeCategory: "DateTime",
        sideSensitive: false,
        category: "Order",
    },
    LastModifiedAt: {
        key: "LastModifiedAt",
        name: "Last Modified At",
        columnTypeCategory: "DateTime",
        sideSensitive: false,
        category: "Order",
    },
    LastUpdateUser: {
        key: "LastUpdateUser",
        name: "Last Update User",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    Limit: {
        key: "Limit",
        name: "Limit",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Order",
    },
    ListAlias: {
        key: "ListAlias",
        name: "List Alias",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Program Trading",
    },
    ListId: {
        key: "ListId",
        name: "List Id",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Program Trading",
    },
    ListSeqNo: {
        key: "ListSeqNo",
        name: "List Seq No",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Program Trading",
    },
    ListTotalNo: {
        key: "ListTotalNo",
        name: "List Total No",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Program Trading",
    },
    MarketLimitDelta: {
        key: "MarketLimitDelta",
        name: "Market/Limit Delta",
        columnTypeCategory: "SignSensitiveNumber",
        sideSensitive: false,
        category: "Order",
    },
    MarketLimitDeltaPct: {
        key: "MarketLimitDeltaPct",
        name: "Market/Limit Delta %",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Order",
    },
    MaturityDate: {
        key: "MaturityDate",
        name: "Maturity Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Security Master",
    },
    MaxDarkPoolQuantity: {
        key: "MaxDarkPoolQuantity",
        name: "Max Dark Qty",
        columnTypeCategory: "BuySellQuantity",
        sideSensitive: false,
        category: "Execution Route",
    },
    Method: {
        key: "Method",
        name: "Method",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    NDF: {
        key: "NDF",
        name: "NDF",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    NPV: {
        key: "NPV",
        name: "NPV",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Order",
    },
    NativeCS01: {
        key: "NativeCS01",
        name: "Native CS01",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Order",
    },
    NativeDV01: {
        key: "NativeDV01",
        name: "Native DV01",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Order",
    },
    NearAmount: {
        key: "NearAmount",
        name: "Near Amount",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Order",
    },
    NotionalFilledAmount: {
        key: "NotionalFilledAmount",
        name: "Notional Filled Amount",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    NotionalFilledAmountAvgPx: {
        key: "NotionalFilledAmountAvgPx",
        name: "Notional Filled Amt - Avg Px",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    NotionalTradeAmount: {
        key: "NotionalTradeAmount",
        name: "Notional Trade Amount",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    NotionalTradeAmountNtnlCurrency: {
        key: "NotionalTradeAmountNtnlCurrency",
        name: "Notional Trade Amount - Ntnl Ccy",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    NotionalUnfilledAmount: {
        key: "NotionalUnfilledAmount",
        name: "Notional Unfilled Amount",
        columnTypeCategory: "SignedIntegerQuantity",
        sideSensitive: false,
        category: "Proceeds",
    },
    OfferingType: {
        key: "OfferingType",
        name: "Offering Type",
        columnTypeCategory: "Enum",
        sideSensitive: false,
        category: "Order",
    },
    Open: {
        key: "Open",
        name: "Open",
        columnTypeCategory: "BuySellQuantity",
        sideSensitive: false,
        category: "Order",
    },
    OpenPctOf30D_ADV: {
        key: "OpenPctOf30D_ADV",
        name: "Open % of 30D ADV",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    OpenPx: {
        key: "OpenPx",
        name: "Open Px",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Related Market Data",
    },
    OpenVal_NAV: {
        key: "OpenVal_NAV",
        name: "Open Val / NAV",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Proceeds",
    },
    OrderPctOf30D_ADV: {
        key: "OrderPctOf30D_ADV",
        name: "Order % of 30D ADV",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    OrderPctOf3M_ADV: {
        key: "OrderPctOf3M_ADV",
        name: "Order % of 3M ADV",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    OrderDate: {
        key: "OrderDate",
        name: "Order Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Order",
    },
    OrderDays: {
        key: "OrderDays",
        name: "Order Days",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Order",
    },
    OrderId: {
        key: "OrderId",
        name: "Order Id",
        columnTypeCategory: "IdNumber",
        sideSensitive: false,
        category: "Order",
    },
    OrderLifecycleStatus: {
        key: "OrderLifecycleStatus",
        name: "Order Lifecycle Status",
        columnTypeCategory: "Enum",
        sideSensitive: false,
        category: "Order",
    },
    OrderVal_NAV: {
        key: "OrderVal_NAV",
        name: "Order Val / NAV",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Proceeds",
    },
    PBDExposure: {
        key: "PBDExposure",
        name: "PBD Exposure",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Position",
    },
    PBDFilledQty: {
        key: "PBDFilledQty",
        name: "PBD Filled Qty",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Fill Info",
    },
    PBDFilledQtyGlobal: {
        key: "PBDFilledQtyGlobal",
        name: "PBD Filled Qty (Global)",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Fill Info",
    },
    PackageId: {
        key: "PackageId",
        name: "Package Id",
        columnTypeCategory: "IdNumber",
        sideSensitive: false,
        category: "Order",
    },
    PackageIdentifier: {
        key: "PackageIdentifier",
        name: "Package Identifier",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    PackageName: {
        key: "PackageName",
        name: "Package Name",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    PackageSize: {
        key: "PackageSize",
        name: "Package Size",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Order",
    },
    PairsIsAutoAddNameToPositionBlock: {
        key: "PairsIsAutoAddNameToPositionBlock",
        name: "Pairs Auto Add Name To Position Block",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Pairs",
    },
    PairsId: {
        key: "PairsId",
        name: "Pairs Id",
        columnTypeCategory: "IdNumber",
        sideSensitive: false,
        category: "Pairs",
    },
    PairsIdentifier: {
        key: "PairsIdentifier",
        name: "Pairs Identifier",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Pairs",
    },
    PairsIsLongShortPair: {
        key: "PairsIsLongShortPair",
        name: "Pairs LongShort Pair",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Pairs",
    },
    PairsIsMaintainRatio: {
        key: "PairsIsMaintainRatio",
        name: "Pairs Maintain Ratio",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Pairs",
    },
    PairsName: {
        key: "PairsName",
        name: "Pairs Name",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Pairs",
    },
    PairsOrderDate: {
        key: "PairsOrderDate",
        name: "Pairs Order Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Pairs",
    },
    PairsSpreadLimit: {
        key: "PairsSpreadLimit",
        name: "Pairs Spread Limit",
        columnTypeCategory: "SignSensitiveNumber",
        sideSensitive: false,
        category: "Pairs",
    },
    ParentOrderId: {
        key: "ParentOrderId",
        name: "Parent Order Id",
        columnTypeCategory: "IdNumber",
        sideSensitive: false,
        category: "Order",
    },
    PayLegInfo: {
        key: "PayLegInfo",
        name: "Pay Leg Info",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    Placed: {
        key: "Placed",
        name: "Placed",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    PortfolioManager: {
        key: "PortfolioManager",
        name: "Portfolio Manager",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Allocations",
    },
    Position: {
        key: "Position",
        name: "Position",
        columnTypeCategory: "SignSensitiveNumber",
        sideSensitive: false,
        category: "Position",
    },
    PositionPercentNAV: {
        key: "PositionPercentNAV",
        name: "Position % of NAV",
        columnTypeCategory: "Percent",
        sideSensitive: false,
        category: "Order",
    },
    PositionFirmwide: {
        key: "PositionFirmwide",
        name: "Position - Firmwide",
        columnTypeCategory: "SignSensitiveNumber",
        sideSensitive: false,
        category: "Position",
    },
    PositionBlock: {
        key: "PositionBlock",
        name: "Position Block",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Allocations",
    },
    PreviousClosePx: {
        key: "PreviousClosePx",
        name: "Prev Close Px",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Related Market Data",
    },
    PrimaryBroker: {
        key: "PrimaryBroker",
        name: "Primary Broker",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    ProgramId: {
        key: "ProgramId",
        name: "Program Id",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Program Trading",
    },
    ProgramName: {
        key: "ProgramName",
        name: "Program Name",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Program Trading",
    },
    ProgramSeqNo: {
        key: "ProgramSeqNo",
        name: "Program Seq No",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Program Trading",
    },
    ProgramTotalNo: {
        key: "ProgramTotalNo",
        name: "Program Total No",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Program Trading",
    },
    Quantity: {
        key: "Quantity",
        name: "Quantity",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Order",
    },
    QuotingConvention: {
        key: "QuotingConvention",
        name: "Quoting Convention",
        columnTypeCategory: "Enum",
        sideSensitive: false,
        category: "Order",
    },
    RIC: {
        key: "RIC",
        name: "RIC",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    Reconciled: {
        key: "Reconciled",
        name: "Reconciled",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    RecvLegInfo: {
        key: "RecvLegInfo",
        name: "Recv Leg Info",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    ReferenceInstrumentDescription: {
        key: "ReferenceInstrumentDescription",
        name: "Reference Instrument Description",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    ReferenceInstrumentPrice: {
        key: "ReferenceInstrumentPrice",
        name: "Reference Instrument Price",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    ReferenceInstrumentTicker: {
        key: "ReferenceInstrumentTicker",
        name: "Reference Instrument Ticker",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    ReleaseDateTime: {
        key: "ReleaseDateTime",
        name: "Release Date/Time",
        columnTypeCategory: "DateTime",
        sideSensitive: false,
        category: "Order",
    },
    RemainingVolumeOf5DAvg: {
        key: "RemainingVolumeOf5DAvg",
        name: "Remaining Vol of 5D Avg",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    ShortLocateAmountRequested: {
        key: "ShortLocateAmountRequested",
        name: "Req SL Qty",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Order",
    },
    ResultingPercentNAV: {
        key: "ResultingPercentNAV",
        name: "Resulting % NAV",
        columnTypeCategory: "Percent",
        sideSensitive: false,
        category: "Order",
    },
    Resumed: {
        key: "Resumed",
        name: "Resumed",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    SODOpenQuantity: {
        key: "SODOpenQuantity",
        name: "SOD Open Quantity",
        columnTypeCategory: "BuySellQuantity",
        sideSensitive: false,
        category: "Order",
    },
    SODOpenQuantityGlobal: {
        key: "SODOpenQuantityGlobal",
        name: "SOD Open Quantity (Global)",
        columnTypeCategory: "BuySellQuantity",
        sideSensitive: false,
        category: "Order",
    },
    DarkPools: {
        key: "DarkPools",
        name: "Selected Dark Pools",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Execution Route",
    },
    SettleCcy: {
        key: "SettleCcy",
        name: "Settle Ccy",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    SettleDate: {
        key: "SettleDate",
        name: "Settle Dt",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Order",
    },
    ShortInterest: {
        key: "ShortInterest",
        name: "Short Interest",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Related Market Data",
    },
    ShortInterestPctEquityFloat: {
        key: "ShortInterestPctEquityFloat",
        name: "Short Interest % Equity Float",
        columnTypeCategory: "Percent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    SpreadLimit: {
        key: "SpreadLimit",
        name: "Spread Limit",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Program Trading",
    },
    SpreadRatio: {
        key: "SpreadRatio",
        name: "Spread Ratio",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Program Trading",
    },
    StartDate: {
        key: "StartDate",
        name: "Start Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "Order",
    },
    Status: {
        key: "Status",
        name: "Status",
        columnTypeCategory: "Enum",
        sideSensitive: true,
        category: "Order",
    },
    StatusText: {
        key: "StatusText",
        name: "Status Text",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    Stop: {
        key: "Stop",
        name: "Stop",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Order",
    },
    Strategy: {
        key: "Strategy",
        name: "Strategy",
        columnTypeCategory: "Standard",
        sideSensitive: true,
        category: "Execution Route",
    },
    StrategyBook: {
        key: "StrategyBook",
        name: "Strategy Book",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    Strike: {
        key: "Strike",
        name: "Strike",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Security Master",
    },
    SubmissionStatus: {
        key: "SubmissionStatus",
        name: "Submission Status",
        columnTypeCategory: "Enum",
        sideSensitive: true,
        category: "Order",
    },
    SwapOrder: {
        key: "SwapOrder",
        name: "Swap Order",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    SwapType: {
        key: "SwapType",
        name: "Swap Type",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    TIF: {
        key: "TIF",
        name: "TIF",
        columnTypeCategory: "Enum",
        sideSensitive: true,
        category: "Order",
    },
    TRSId: {
        key: "TRSId",
        name: "TRS Id",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Allocations",
    },
    TRSOverridesBenchmarkBBYELLOW: {
        key: "TRSOverridesBenchmarkBBYELLOW",
        name: "TRS Overrides Benchmark BBYELLOW",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesBenchmarkId: {
        key: "TRSOverridesBenchmarkId",
        name: "TRS Overrides Benchmark Id",
        columnTypeCategory: "IdNumber",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesBenchmarkTicker: {
        key: "TRSOverridesBenchmarkTicker",
        name: "TRS Overrides Benchmark Ticker",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesEndDate: {
        key: "TRSOverridesEndDate",
        name: "TRS Overrides End Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesPayLegFirstResetDate: {
        key: "TRSOverridesPayLegFirstResetDate",
        name: "TRS Overrides Pay Leg First Reset Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesPayLegLastResetDate: {
        key: "TRSOverridesPayLegLastResetDate",
        name: "TRS Overrides Pay Leg Last Reset Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesPayLegResetFrequency: {
        key: "TRSOverridesPayLegResetFrequency",
        name: "TRS Overrides Pay Leg Reset Frequency",
        columnTypeCategory: "Enum",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesRate: {
        key: "TRSOverridesRate",
        name: "TRS Overrides Rate",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesRateEffectiveDate: {
        key: "TRSOverridesRateEffectiveDate",
        name: "TRS Overrides Rate Effective Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesRecLegFirstResetDate: {
        key: "TRSOverridesRecLegFirstResetDate",
        name: "TRS Overrides Rec Leg First Reset Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesRecLegLastResetDate: {
        key: "TRSOverridesRecLegLastResetDate",
        name: "TRS Overrides Rec Leg Last Reset Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    TRSOverridesStartDate: {
        key: "TRSOverridesStartDate",
        name: "TRS Overrides Start Date",
        columnTypeCategory: "Date",
        sideSensitive: false,
        category: "TRS Overrides",
    },
    Tenor: {
        key: "Tenor",
        name: "Tenor",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    Ticker: {
        key: "Ticker",
        name: "Ticker",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    TodayAvgPx: {
        key: "TodayAvgPx",
        name: "Today Avg Px",
        columnTypeCategory: "AveragePrice",
        sideSensitive: false,
        category: "Fill Info",
    },
    TodayAvgPxGlobal: {
        key: "TodayAvgPxGlobal",
        name: "Today Avg Px (Global)",
        columnTypeCategory: "AveragePrice",
        sideSensitive: false,
        category: "Fill Info",
    },
    TodayCommitted: {
        key: "TodayCommitted",
        name: "Today Committed",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Order",
    },
    TodayCommittedGlobal: {
        key: "TodayCommittedGlobal",
        name: "Today Committed (Global)",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Order",
    },
    TodayFilledPct: {
        key: "TodayFilledPct",
        name: "Today Filled %",
        columnTypeCategory: "PercentFilled",
        sideSensitive: false,
        category: "Fill Info",
    },
    TodayFilledQty: {
        key: "TodayFilledQty",
        name: "Today Filled Qty",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Fill Info",
    },
    TodayFilledQtyGlobal: {
        key: "TodayFilledQtyGlobal",
        name: "Today Filled Qty (Global)",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Fill Info",
    },
    TodayFilledQtyPctNav: {
        key: "TodayFilledQtyPctNav",
        name: "Today Filled Qty as % NAV",
        columnTypeCategory: "Percent",
        sideSensitive: false,
        category: "Fill Info",
    },
    TradeReason: {
        key: "TradeReason",
        name: "Trade Reason",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    TradeSpread: {
        key: "TradeSpread",
        name: "Trade Spread",
        columnTypeCategory: "SignedQuantity",
        sideSensitive: false,
        category: "Order",
    },
    Trader: {
        key: "Trader",
        name: "Trader",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    TraderDiscretion: {
        key: "TraderDiscretion",
        name: "Trader Discretion",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    TradingDesk: {
        key: "TradingDesk",
        name: "Trading Desk",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    Txn: {
        key: "Txn",
        name: "Txn",
        columnTypeCategory: "Standard",
        sideSensitive: true,
        category: "Order",
    },
    Type: {
        key: "Type",
        name: "Type",
        columnTypeCategory: "Enum",
        sideSensitive: true,
        category: "Order",
    },
    Underlier: {
        key: "Underlier",
        name: "Underlier",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Security Master",
    },
    UnderlyingAsk: {
        key: "UnderlyingAsk",
        name: "Underlying Ask",
        columnTypeCategory: "Quotation",
        sideSensitive: false,
        category: "Related Market Data",
    },
    UnderlyingBid: {
        key: "UnderlyingBid",
        name: "Underlying Bid",
        columnTypeCategory: "Quotation",
        sideSensitive: false,
        category: "Related Market Data",
    },
    UnderlyingLast: {
        key: "UnderlyingLast",
        name: "Underlying Last",
        columnTypeCategory: "Quotation",
        sideSensitive: false,
        category: "Related Market Data",
    },
    UnderlyingNotionalAmt: {
        key: "UnderlyingNotionalAmt",
        name: "Underlying Notional Amt",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Order",
    },
    UndisclosedShort: {
        key: "UndisclosedShort",
        name: "Undisclosed Short",
        columnTypeCategory: "Boolean",
        sideSensitive: false,
        category: "Order",
    },
    UnFilledPct: {
        key: "UnFilledPct",
        name: "Unfilled %",
        columnTypeCategory: "PercentFilled",
        sideSensitive: false,
        category: "Fill Info",
    },
    UnfilledPctOf3M_ADV: {
        key: "UnfilledPctOf3M_ADV",
        name: "Unfilled % of 3M ADV",
        columnTypeCategory: "SignSensitivePercent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    UnfilledPercentNAV: {
        key: "UnfilledPercentNAV",
        name: "Unfilled % of NAV",
        columnTypeCategory: "Percent",
        sideSensitive: false,
        category: "Order",
    },
    UnfilledQty: {
        key: "UnfilledQty",
        name: "Unfilled Qty",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Fill Info",
    },
    VWAP: {
        key: "VWAP",
        name: "VWAP",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Related Market Data",
    },
    FilledPctOfVWAPShares: {
        key: "FilledPctOfVWAPShares",
        name: "VWAP %",
        columnTypeCategory: "Percent",
        sideSensitive: false,
        category: "Related Market Data",
    },
    VWAPShares: {
        key: "VWAPShares",
        name: "VWAP Shares",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    VarianceUnits: {
        key: "VarianceUnits",
        name: "Variance Units",
        columnTypeCategory: "MarketPrice",
        sideSensitive: false,
        category: "Related Market Data",
    },
    Volume: {
        key: "Volume",
        name: "Volume",
        columnTypeCategory: "IntegerNumber",
        sideSensitive: false,
        category: "Related Market Data",
    },
    WorkflowState: {
        key: "WorkflowState",
        name: "Workflow State",
        columnTypeCategory: "Standard",
        sideSensitive: false,
        category: "Order",
    },
    Working: {
        key: "Working",
        name: "Working",
        columnTypeCategory: "Number",
        sideSensitive: false,
        category: "Order",
    },
};
export const oemsBlotterColumns = [
    {
        f: "_Control_",
        n: "Actions",
        t: "standardColumn",
        w: 150,
        c: "Other",
        suppressMenu: true,
        sortable: false,
        pinned: "right",
    },
    {
        f: "completed",
        n: "Completed",
        t: "standardColumn",
        c: "Order",
        hide: true,
        lockVisible: true,
    },
    {
        f: "columnValues.CommittedAmtBookCurrency",
        n: "$ Committed Amount",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.NotionalFilledAmountBookCurrency",
        n: "$ Notional Filled Amount",
        t: "numericColumn",
        c: "Proceeds",
    },
    {
        f: "columnValues.NotionalFilledAmountAvgPxBookCurrency",
        n: "$ Notional Filled Amt - Avg Px",
        t: "numericColumn",
        c: "Proceeds",
    },
    {
        f: "columnValues.NotionalTradeAmountBookCurrency",
        n: "$ Notional Trade Amount",
        t: "numericColumn",
        c: "Proceeds",
    },
    {
        f: "columnValues.NotionalUnfilledAmountBookCurrency",
        n: "$ Notional Unfilled Amount",
        t: "numericColumn",
        c: "Proceeds",
    },
    {
        f: "columnValues.SODNotionalTradeAmtBookCcy",
        n: "$ SOD Notional Trade Amount (Global)",
        t: "numericColumn",
        c: "Proceeds",
    },
    {
        f: "columnValues.TodayNotionalFilledAmtBookCcy",
        n: "$ Today Notional Filled Amount (Global)",
        t: "numericColumn",
        c: "Proceeds",
    },
    {
        f: "columnValues._20DAvgVol",
        n: "20D Avg Vol",
        t: "numericColumn",
        w: 110,
        c: "Related Market Data",
    },
    {
        f: "columnValues._30DAvgVol",
        n: "30D Avg Vol",
        t: "numericColumn",
        w: 110,
        c: "Related Market Data",
    },
    {
        f: "columnValues._3MAvgVol",
        n: "3M Avg Vol",
        t: "numericColumn",
        w: 105,
        c: "Related Market Data",
    },
    {
        f: "columnValues._5DAvgVol",
        n: "5D Avg Vol",
        t: "numericColumn",
        w: 104,
        c: "Related Market Data",
    },
    {
        f: "columnValues.AccountNumber",
        n: "Account Number",
        t: "standardColumn",
        c: "Allocations",
    },
    {
        f: "columnValues.AllocationInstructions",
        n: "Alloc Instr",
        t: "standardColumn",
        w: 197,
        c: "Allocations",
    },
    {
        f: "columnValues.AllocationReason",
        n: "Allocation Reason",
        t: "standardColumn",
        w: 142,
        c: "Order",
    },
    {
        f: "columnValues.ShortLocateAmountApproved",
        n: "Apr SL Qty",
        t: "numericColumn",
        w: 102,
        c: "Order",
    },
    {
        f: "columnValues.ArrivalPctChange",
        n: "Arrival % Change",
        t: "numericColumn",
        w: 137,
        c: "Order",
    },
    {
        f: "columnValues.ArrivalPrice",
        n: "Arrival Price",
        t: "numericColumn",
        w: 110,
        c: "Order",
    },
    {
        f: "columnValues.ArrivalVWAP",
        n: "Arrival VWAP",
        t: "numericColumn",
        w: 117,
        c: "Order",
    },
    {
        f: "columnValues.Ask",
        n: "Ask",
        t: "standardColumn",
        w: 105,
        c: "Related Market Data",
    },
    {
        f: "columnValues.AssignedCpty",
        n: "Assigned Cpty",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.AssignedSLID",
        n: "Assigned SL ID",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.ShortLocateAmountAssigned",
        n: "Assigned SL Qty",
        t: "numericColumn",
        w: 132,
        c: "Order",
    },
    {
        f: "columnValues.AvgPx",
        n: "Avg Px",
        t: "numericColumn",
        w: 81,
        c: "Fill Info",
    },
    {
        f: "columnValues.BBFutureRoot",
        n: "BB Future Root",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.BBTicker",
        n: "BB Ticker",
        t: "standardColumn",
        w: 135,
        c: "Security Master",
    },
    {
        f: "columnValues.Bid",
        n: "Bid",
        t: "standardColumn",
        w: 105,
        c: "Related Market Data",
    },
    {
        f: "columnValues.BidAskDelta",
        n: "Bid/Ask Delta",
        t: "numericColumn",
        w: 118,
        c: "Related Market Data",
    },
    {
        f: "columnValues.BilateralCleared",
        n: "Bilateral/Cleared",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.BookCS01",
        n: "Book CS01",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.BookDV01",
        n: "Book DV01",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.BookName",
        n: "Book Name",
        t: "standardColumn",
        w: 107,
        c: "Allocations",
    },
    {
        f: "columnValues.Broker",
        n: "Broker",
        t: "standardColumn",
        w: 183,
        c: "Execution Route",
    },
    {
        f: "columnValues.BrokerAccount",
        n: "Broker Account",
        t: "standardColumn",
        w: 128,
        c: "Execution Route",
    },
    {
        f: "columnValues.CCP",
        n: "CCP",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.CalculatorType",
        n: "Calculator Type",
        t: "standardColumn",
        w: 158,
        c: "Order",
    },
    {
        f: "columnValues.Cap",
        n: "Cap?",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.Ccy",
        n: "Ccy",
        t: "standardColumn",
        w: 68,
        c: "Security Master",
    },
    {
        f: "columnValues.Change",
        n: "Change",
        t: "numericColumn",
        w: 86,
        c: "Related Market Data",
    },
    {
        f: "columnValues.ChangePct",
        n: "Change(%)",
        t: "numericColumn",
        w: 104,
        c: "Related Market Data",
    },
    {
        f: "columnValues.ChangesToAcknowledge",
        n: "Changes to Ack",
        t: "standardColumn",
        w: 128,
        c: "Order",
    },
    {
        f: "columnValues.ClearingAccount",
        n: "Clearing Account",
        t: "standardColumn",
        w: 175,
        c: "Allocations",
    },
    {
        f: "columnValues.CommissionRate",
        n: "Comm Rate",
        t: "numericColumn",
        w: 108,
        c: "Proceeds",
    },
    {
        f: "columnValues.CommissionRateType",
        n: "Comm Rate Type",
        t: "standardColumn",
        w: 137,
        c: "Proceeds",
    },
    {
        f: "columnValues.CommissionTotal",
        n: "Comm Total",
        t: "numericColumn",
        w: 110,
        c: "Proceeds",
    },
    {
        f: "columnValues.Committed",
        n: "Committed",
        t: "numericColumn",
        w: 106,
        c: "Order",
    },
    {
        f: "columnValues.CommittedPct",
        n: "Committed %",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.CommittedAmt",
        n: "Committed Amount",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.CompletedDate",
        n: "Completed Dt",
        t: "dateColumn",
        w: 175,
        c: "Order",
    },
    {
        f: "columnValues.CompletionStatus",
        n: "Completion Status",
        t: "standardColumn",
        w: 145,
        c: "Order",
    },
    {
        f: "columnValues.Compliance",
        n: "Compliance",
        t: "standardColumn",
        w: 122,
        c: "Order",
    },
    {
        f: "columnValues.ComplianceNotes",
        n: "Compliance Notes",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.ContraCcy",
        n: "Contra Ccy",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.Contract",
        n: "Contract",
        t: "standardColumn",
        w: 244,
        c: "Security Master",
    },
    {
        f: "columnValues.ContractSize",
        n: "Contract Size",
        t: "numericColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.Counterparty",
        n: "Counterparty",
        t: "standardColumn",
        w: 117,
        c: "Execution Route",
    },
    {
        f: "columnValues.CounterpartyMemo",
        n: "Cpty Memo",
        t: "standardColumn",
        w: 107,
        c: "Execution Route",
    },
    {
        f: "columnValues.CreationDate",
        n: "Creation Date",
        t: "dateColumn",
        c: "Order",
    },
    {
        f: "columnValues.OrderCreationMethod",
        n: "Creation Method",
        t: "standardColumn",
        w: 200,
        c: "Order",
    },
    {
        f: "columnValues.CreationPrice",
        n: "Creation Price",
        t: "numericColumn",
        w: 121,
        c: "Order",
    },
    {
        f: "columnValues.CreditDirection",
        n: "Credit Direction",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.DayParticipationRate",
        n: "Day Participation Rate",
        t: "numericColumn",
        c: "Related Market Data",
    },
    {
        f: "columnValues.DayParticipationShares",
        n: "Day Participation Shares",
        t: "numericColumn",
        c: "Related Market Data",
    },
    {
        f: "columnValues.DealId",
        n: "Deal Id",
        t: "standardColumn",
        c: "Allocations",
    },
    {
        f: "columnValues.DealSpread",
        n: "Deal Spread",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.DealTerms",
        n: "Deal Terms",
        t: "standardColumn",
        c: "Program Trading",
    },
    {
        f: "columnValues.Delta",
        n: "Delta",
        t: "numericColumn",
        c: "Related Market Data",
    },
    {
        f: "columnValues.DeltaAdjExposure",
        n: "Delta Adjusted Exposure",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.Destination",
        n: "Destination",
        t: "standardColumn",
        w: 212,
        c: "Execution Route",
    },
    {
        f: "columnValues.EffectiveDate",
        n: "Effective Date",
        t: "dateColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.Proceeds",
        n: "Estimated Proceeds",
        t: "numericColumn",
        w: 153,
        c: "Proceeds",
    },
    {
        f: "columnValues.ExchangeCountryCode",
        n: "Exch Country Code",
        t: "standardColumn",
        w: 147,
        c: "Security Master",
    },
    {
        f: "columnValues.ExchangeCountryName",
        n: "Exch Country Name",
        t: "standardColumn",
        w: 151,
        c: "Security Master",
    },
    {
        f: "columnValues.Exchange",
        n: "Exchange",
        t: "standardColumn",
        w: 140,
        c: "Security Master",
    },
    {
        f: "columnValues.ExchangeMIC",
        n: "Exchange MIC Code",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.ExecVal_NAV",
        n: "Exec Val / NAV",
        t: "numericColumn",
        w: 123,
        c: "Proceeds",
    },
    {
        f: "columnValues.ExecutedExposureBPS",
        n: "Executed Exposure (BPS)",
        t: "numericColumn",
        w: 181,
        c: "Order",
    },
    {
        f: "columnValues.Exposure",
        n: "Exposure",
        t: "numericColumn",
        w: 95,
        c: "Position",
    },
    {
        f: "columnValues.ExposureChange",
        n: "Exposure Change",
        t: "numericColumn",
        w: 139,
        c: "Position",
    },
    {
        f: "columnValues.FCM",
        n: "FCM",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.FIXOrderId",
        n: "FIX Order Id",
        t: "standardColumn",
        w: 220,
        c: "Execution Route",
    },
    {
        f: "columnValues.SettleToBookFXRate",
        n: "FX Rate",
        t: "standardColumn",
        w: 87,
        c: "Related Market Data",
    },
    {
        f: "columnValues.FarAmount",
        n: "Far Amount",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.FXFarFixingDate",
        n: "Far Fixing Date",
        t: "dateColumn",
        w: 125,
        c: "Security Master",
    },
    {
        f: "columnValues.FXFarForwardDate",
        n: "Far Forward Date",
        t: "dateColumn",
        w: 138,
        c: "Security Master",
    },
    {
        f: "columnValues.FillPriceDeviation",
        n: "Fill Px % Deviation",
        t: "numericColumn",
        w: 145,
        c: "Related Market Data",
    },
    {
        f: "columnValues.Filled",
        n: "Filled",
        t: "numericColumn",
        w: 81,
        c: "Fill Info",
    },
    {
        f: "columnValues.FilledPctOf30D_ADV",
        n: "Filled  % of 30D ADV",
        t: "numericColumn",
        w: 154,
        c: "Related Market Data",
    },
    {
        f: "columnValues.FilledPct",
        n: "Filled %",
        t: "numericColumn",
        w: 87,
        c: "Fill Info",
    },
    {
        f: "columnValues.FilledPctOf3M_ADV",
        n: "Filled % of 3M ADV",
        t: "numericColumn",
        w: 149,
        c: "Related Market Data",
    },
    {
        f: "columnValues.FirstCounterparty",
        n: "First Counterparty",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.FirstFilledDate",
        n: "First Filled Dt",
        t: "dateColumn",
        w: 181,
        c: "Order",
    },
    {
        f: "columnValues.FirstTransmittedDate",
        n: "First Transmit Dt",
        t: "dateColumn",
        w: 181,
        c: "Order",
    },
    {
        f: "columnValues.FixedRate",
        n: "Fixed Rate",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.FXFixingDate",
        n: "Fixing Date",
        t: "dateColumn",
        w: 106,
        c: "Security Master",
    },
    {
        f: "columnValues.ForwardDate",
        n: "Forward Date",
        t: "dateColumn",
        c: "Order",
    },
    {
        f: "columnValues.FullyAdjustedPrevLastPx",
        n: "Fully Adj Prev Last Px",
        t: "numericColumn",
        c: "Related Market Data",
    },
    {
        f: "columnValues.FundFullName",
        n: "Fund Full Name",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.FundName",
        n: "Fund Name",
        t: "standardColumn",
        w: 106,
        c: "Allocations",
    },
    {
        f: "columnValues.GICGroup",
        n: "GIC Group",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.GICIndustry",
        n: "GIC Industry",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.GICSector",
        n: "GIC Sector",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.GICSubIndustry",
        n: "GIC Sub Industry",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.ISIN",
        n: "ISIN",
        t: "standardColumn",
        w: 133,
        c: "Security Master",
    },
    {
        f: "columnValues.Idle",
        n: "Idle",
        t: "numericColumn",
        w: 81,
        c: "Order",
    },
    {
        f: "columnValues.ImpactVWAP",
        n: "Impact VWAP",
        t: "numericColumn",
        w: 119,
        c: "Related Market Data",
    },
    {
        f: "columnValues.FilledPctOfImpactVWAPShares",
        n: "Impact VWAP %",
        t: "numericColumn",
        w: 132,
        c: "Related Market Data",
    },
    {
        f: "columnValues.ImpactVWAPAvgPxDelta",
        n: "Impact VWAP / Avg Px Delta",
        t: "numericColumn",
        w: 198,
        c: "Related Market Data",
    },
    {
        f: "columnValues.ImpactVWAPShares",
        n: "Impact VWAP Shares",
        t: "numericColumn",
        w: 158,
        c: "Related Market Data",
    },
    {
        f: "columnValues.Instructions",
        n: "Instructions",
        t: "standardColumn",
        w: 109,
        c: "Order",
    },
    {
        f: "columnValues.InstrumentId",
        n: "Instrument Id",
        t: "numericColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.InstrumentSubtype",
        n: "Instrument Subtype",
        t: "standardColumn",
        w: 167,
        c: "Security Master",
    },
    {
        f: "columnValues.InstrumentType",
        n: "Instrument Type",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.IsActiveParent",
        n: "Is Active Parent",
        t: "standardColumn",
        w: 129,
        c: "Order",
    },
    {
        f: "columnValues.IsCurrentlyScheduled",
        n: "Is Currently Scheduled",
        t: "standardColumn",
        w: 166,
        c: "Order",
    },
    {
        f: "columnValues.isExecutionRoute",
        n: "Is Execution Route",
        t: "standardColumn",
        w: 145,
        c: "Order",
    },
    {
        f: "columnValues.IsForceCancel",
        n: "Is Force Cancel",
        t: "standardColumn",
        w: 125,
        c: "Order",
    },
    {
        f: "columnValues.IsStale",
        n: "Is Stale",
        t: "standardColumn",
        w: 83,
        c: "Order",
    },
    {
        f: "columnValues.Undecided",
        n: "Is Undecided",
        t: "standardColumn",
        w: 114,
        c: "Order",
    },
    {
        f: "columnValues.IsUnsolicitedCancel",
        n: "Is Unsolicited Cancel",
        t: "standardColumn",
        w: 156,
        c: "Order",
    },
    {
        f: "columnValues.Issuer",
        n: "Issuer",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.Last",
        n: "Last",
        t: "standardColumn",
        w: 105,
        c: "Related Market Data",
    },
    {
        f: "columnValues.LastFillPx",
        n: "Last Fill Px",
        t: "numericColumn",
        w: 102,
        c: "Fill Info",
    },
    {
        f: "columnValues.LastFillQty",
        n: "Last Fill Quantity",
        t: "numericColumn",
        c: "Fill Info",
    },
    {
        f: "columnValues.LastFilledDate",
        n: "Last Filled Dt",
        t: "dateColumn",
        w: 181,
        c: "Order",
    },
    {
        f: "columnValues.LastModifiedAt",
        n: "Last Modified At",
        t: "dateColumn",
        w: 181,
        c: "Order",
    },
    {
        f: "columnValues.LastUpdateUser",
        n: "Last Update User",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.Limit",
        n: "Limit",
        t: "numericColumn",
        w: 84,
        c: "Order",
    },
    {
        f: "columnValues.ListAlias",
        n: "List Alias",
        t: "standardColumn",
        w: 93,
        c: "Program Trading",
    },
    {
        f: "columnValues.ListId",
        n: "List Id",
        t: "standardColumn",
        w: 77,
        c: "Program Trading",
    },
    {
        f: "columnValues.ListSeqNo",
        n: "List Seq No",
        t: "numericColumn",
        w: 105,
        c: "Program Trading",
    },
    {
        f: "columnValues.ListTotalNo",
        n: "List Total No",
        t: "numericColumn",
        w: 113,
        c: "Program Trading",
    },
    {
        f: "columnValues.MarketLimitDelta",
        n: "Market/Limit Delta",
        t: "numericColumn",
        w: 148,
        c: "Order",
    },
    {
        f: "columnValues.MarketLimitDeltaPct",
        n: "Market/Limit Delta %",
        t: "numericColumn",
        w: 161,
        c: "Order",
    },
    {
        f: "columnValues.MaturityDate",
        n: "Maturity Date",
        t: "dateColumn",
        w: 120,
        c: "Security Master",
    },
    {
        f: "columnValues.MaxDarkPoolQuantity",
        n: "Max Dark Qty",
        t: "numericColumn",
        c: "Execution Route",
    },
    {
        f: "columnValues.Method",
        n: "Method",
        t: "standardColumn",
        w: 103,
        c: "Order",
    },
    {
        f: "columnValues.NDF",
        n: "NDF",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.NPV",
        n: "NPV",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.NativeCS01",
        n: "Native CS01",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.NativeDV01",
        n: "Native DV01",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.NearAmount",
        n: "Near Amount",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.NotionalFilledAmount",
        n: "Notional Filled Amount",
        t: "numericColumn",
        w: 171,
        c: "Proceeds",
    },
    {
        f: "columnValues.NotionalFilledAmountAvgPx",
        n: "Notional Filled Amt - Avg Px",
        t: "numericColumn",
        c: "Proceeds",
    },
    {
        f: "columnValues.NotionalTradeAmount",
        n: "Notional Trade Amount",
        t: "numericColumn",
        w: 172,
        c: "Proceeds",
    },
    {
        f: "columnValues.NotionalTradeAmountNtnlCurrency",
        n: "Notional Trade Amount - Ntnl Ccy",
        t: "numericColumn",
        c: "Proceeds",
    },
    {
        f: "columnValues.NotionalUnfilledAmount",
        n: "Notional Unfilled Amount",
        t: "numericColumn",
        w: 184,
        c: "Proceeds",
    },
    {
        f: "columnValues.OfferingType",
        n: "Offering Type",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.Open",
        n: "Open",
        t: "numericColumn",
        w: 81,
        c: "Order",
    },
    {
        f: "columnValues.OpenPctOf30D_ADV",
        n: "Open % of 30D ADV",
        t: "numericColumn",
        w: 154,
        c: "Related Market Data",
    },
    {
        f: "columnValues.OpenPx",
        n: "Open Px",
        t: "numericColumn",
        w: 91,
        c: "Related Market Data",
    },
    {
        f: "columnValues.OpenVal_NAV",
        n: "Open Val / NAV",
        t: "numericColumn",
        w: 128,
        c: "Proceeds",
    },
    {
        f: "columnValues.OrderPctOf30D_ADV",
        n: "Order % of 30D ADV",
        t: "numericColumn",
        w: 156,
        c: "Related Market Data",
    },
    {
        f: "columnValues.OrderPctOf3M_ADV",
        n: "Order % of 3M ADV",
        t: "numericColumn",
        w: 151,
        c: "Related Market Data",
    },
    {
        f: "columnValues.OrderDate",
        n: "Order Date",
        t: "dateColumn",
        w: 108,
        c: "Order",
    },
    {
        f: "columnValues.OrderDays",
        n: "Order Days",
        t: "numericColumn",
        w: 105,
        c: "Order",
    },
    {
        f: "columnValues.OrderId",
        n: "Order Id",
        t: "numericColumn",
        w: 92,
        c: "Order",
    },
    {
        f: "columnValues.OrderLifecycleStatus",
        n: "Order Lifecycle Status",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.OrderVal_NAV",
        n: "Order Val / NAV",
        t: "numericColumn",
        w: 131,
        c: "Proceeds",
    },
    {
        f: "columnValues.PBDExposure",
        n: "PBD Exposure",
        t: "numericColumn",
        w: 122,
        c: "Position",
    },
    {
        f: "columnValues.PBDFilledQty",
        n: "PBD Filled Qty",
        t: "numericColumn",
        w: 124,
        c: "Fill Info",
    },
    {
        f: "columnValues.PBDFilledQtyGlobal",
        n: "PBD Filled Qty (Global)",
        t: "numericColumn",
        c: "Fill Info",
    },
    {
        f: "columnValues.PackageId",
        n: "Package Id",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.PackageIdentifier",
        n: "Package Identifier",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.PackageName",
        n: "Package Name",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.PackageSize",
        n: "Package Size",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.PairsIsAutoAddNameToPositionBlock",
        n: "Pairs Auto Add Name To Position Block",
        t: "standardColumn",
        c: "Pairs",
    },
    {
        f: "columnValues.PairsId",
        n: "Pairs Id",
        t: "numericColumn",
        c: "Pairs",
    },
    {
        f: "columnValues.PairsIdentifier",
        n: "Pairs Identifier",
        t: "standardColumn",
        c: "Pairs",
    },
    {
        f: "columnValues.PairsIsLongShortPair",
        n: "Pairs LongShort Pair",
        t: "standardColumn",
        c: "Pairs",
    },
    {
        f: "columnValues.PairsIsMaintainRatio",
        n: "Pairs Maintain Ratio",
        t: "standardColumn",
        c: "Pairs",
    },
    {
        f: "columnValues.PairsName",
        n: "Pairs Name",
        t: "standardColumn",
        c: "Pairs",
    },
    {
        f: "columnValues.PairsOrderDate",
        n: "Pairs Order Date",
        t: "dateColumn",
        c: "Pairs",
    },
    {
        f: "columnValues.PairsSpreadLimit",
        n: "Pairs Spread Limit",
        t: "numericColumn",
        c: "Pairs",
    },
    {
        f: "columnValues.ParentOrderId",
        n: "Parent Order Id",
        t: "numericColumn",
        w: 129,
        c: "Order",
    },
    {
        f: "columnValues.PayLegInfo",
        n: "Pay Leg Info",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.Placed",
        n: "Placed",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.PortfolioManager",
        n: "Portfolio Manager",
        t: "standardColumn",
        w: 138,
        c: "Allocations",
    },
    {
        f: "columnValues.Position",
        n: "Position",
        t: "numericColumn",
        w: 92,
        c: "Position",
    },
    {
        f: "columnValues.PositionPercentNAV",
        n: "Position % of NAV",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.PositionFirmwide",
        n: "Position - Firmwide",
        t: "numericColumn",
        c: "Position",
    },
    {
        f: "columnValues.PositionBlock",
        n: "Position Block",
        t: "standardColumn",
        c: "Allocations",
    },
    {
        f: "columnValues.PreviousClosePx",
        n: "Prev Close Px",
        t: "numericColumn",
        w: 118,
        c: "Related Market Data",
    },
    {
        f: "columnValues.PrimaryBroker",
        n: "Primary Broker",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.ProgramId",
        n: "Program Id",
        t: "standardColumn",
        c: "Program Trading",
    },
    {
        f: "columnValues.ProgramName",
        n: "Program Name",
        t: "standardColumn",
        c: "Program Trading",
    },
    {
        f: "columnValues.ProgramSeqNo",
        n: "Program Seq No",
        t: "numericColumn",
        c: "Program Trading",
    },
    {
        f: "columnValues.ProgramTotalNo",
        n: "Program Total No",
        t: "numericColumn",
        c: "Program Trading",
    },
    {
        f: "columnValues.Quantity",
        n: "Quantity",
        t: "numericColumn",
        w: 93,
        c: "Order",
    },
    {
        f: "columnValues.QuotingConvention",
        n: "Quoting Convention",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.RIC",
        n: "RIC",
        t: "standardColumn",
        w: 95,
        c: "Security Master",
    },
    {
        f: "columnValues.Reconciled",
        n: "Reconciled",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.RecvLegInfo",
        n: "Recv Leg Info",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.ReferenceInstrumentDescription",
        n: "Reference Instrument Description",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.ReferenceInstrumentPrice",
        n: "Reference Instrument Price",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.ReferenceInstrumentTicker",
        n: "Reference Instrument Ticker",
        t: "standardColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.ReleaseDateTime",
        n: "Release Date/Time",
        t: "dateColumn",
        w: 148,
        c: "Order",
    },
    {
        f: "columnValues.RemainingVolumeOf5DAvg",
        n: "Remaining Vol of 5D Avg",
        t: "numericColumn",
        w: 178,
        c: "Related Market Data",
    },
    {
        f: "columnValues.ShortLocateAmountRequested",
        n: "Req SL Qty",
        t: "numericColumn",
        w: 104,
        c: "Order",
    },
    {
        f: "columnValues.ResultingPercentNAV",
        n: "Resulting % NAV",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.Resumed",
        n: "Resumed",
        t: "standardColumn",
        w: 95,
        c: "Order",
    },
    {
        f: "columnValues.SODOpenQuantity",
        n: "SOD Open Quantity",
        t: "numericColumn",
        w: 152,
        c: "Order",
    },
    {
        f: "columnValues.SODOpenQuantityGlobal",
        n: "SOD Open Quantity (Global)",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.DarkPools",
        n: "Selected Dark Pools",
        t: "standardColumn",
        w: 153,
        c: "Execution Route",
    },
    {
        f: "columnValues.SettleCcy",
        n: "Settle Ccy",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.SettleDate",
        n: "Settle Dt",
        t: "dateColumn",
        c: "Order",
    },
    {
        f: "columnValues.ShortInterest",
        n: "Short Interest",
        t: "numericColumn",
        w: 120,
        c: "Related Market Data",
    },
    {
        f: "columnValues.ShortInterestPctEquityFloat",
        n: "Short Interest % Equity Float",
        t: "numericColumn",
        w: 201,
        c: "Related Market Data",
    },
    {
        f: "columnValues.SpreadLimit",
        n: "Spread Limit",
        t: "standardColumn",
        c: "Program Trading",
    },
    {
        f: "columnValues.SpreadRatio",
        n: "Spread Ratio",
        t: "standardColumn",
        c: "Program Trading",
    },
    {
        f: "columnValues.StartDate",
        n: "Start Date",
        t: "dateColumn",
        c: "Order",
    },
    {
        f: "columnValues.Status",
        n: "Status",
        t: "standardColumn",
        w: 125,
        c: "Order",
    },
    {
        f: "columnValues.StatusText",
        n: "Status Text",
        t: "standardColumn",
        w: 878,
        c: "Order",
    },
    {
        f: "columnValues.Stop",
        n: "Stop",
        t: "numericColumn",
        w: 70,
        c: "Order",
    },
    {
        f: "columnValues.Strategy",
        n: "Strategy",
        t: "standardColumn",
        w: 110,
        c: "Execution Route",
    },
    {
        f: "columnValues.StrategyBook",
        n: "Strategy Book",
        t: "standardColumn",
        w: 122,
        c: "Order",
    },
    {
        f: "columnValues.Strike",
        n: "Strike",
        t: "numericColumn",
        c: "Security Master",
    },
    {
        f: "columnValues.SubmissionStatus",
        n: "Submission Status",
        t: "standardColumn",
        w: 143,
        c: "Order",
    },
    {
        f: "columnValues.SwapOrder",
        n: "Swap Order",
        t: "standardColumn",
        w: 109,
        c: "Order",
    },
    {
        f: "columnValues.SwapType",
        n: "Swap Type",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.TIF",
        n: "TIF",
        t: "standardColumn",
        w: 66,
        c: "Order",
    },
    {
        f: "columnValues.TRSId",
        n: "TRS Id",
        t: "standardColumn",
        c: "Allocations",
    },
    {
        f: "columnValues.TRSOverridesBenchmarkBBYELLOW",
        n: "TRS Overrides Benchmark BBYELLOW",
        t: "standardColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesBenchmarkId",
        n: "TRS Overrides Benchmark Id",
        t: "numericColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesBenchmarkTicker",
        n: "TRS Overrides Benchmark Ticker",
        t: "standardColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesEndDate",
        n: "TRS Overrides End Date",
        t: "dateColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesPayLegFirstResetDate",
        n: "TRS Overrides Pay Leg First Reset Date",
        t: "dateColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesPayLegLastResetDate",
        n: "TRS Overrides Pay Leg Last Reset Date",
        t: "dateColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesPayLegResetFrequency",
        n: "TRS Overrides Pay Leg Reset Frequency",
        t: "standardColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesRate",
        n: "TRS Overrides Rate",
        t: "standardColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesRateEffectiveDate",
        n: "TRS Overrides Rate Effective Date",
        t: "dateColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesRecLegFirstResetDate",
        n: "TRS Overrides Rec Leg First Reset Date",
        t: "dateColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesRecLegLastResetDate",
        n: "TRS Overrides Rec Leg Last Reset Date",
        t: "dateColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.TRSOverridesStartDate",
        n: "TRS Overrides Start Date",
        t: "dateColumn",
        c: "TRS Overrides",
    },
    {
        f: "columnValues.Tenor",
        n: "Tenor",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.Ticker",
        n: "Ticker",
        t: "standardColumn",
        w: 80,
        c: "Security Master",
    },
    {
        f: "columnValues.TodayAvgPx",
        n: "Today Avg Px",
        t: "numericColumn",
        w: 116,
        c: "Fill Info",
    },
    {
        f: "columnValues.TodayAvgPxGlobal",
        n: "Today Avg Px (Global)",
        t: "numericColumn",
        c: "Fill Info",
    },
    {
        f: "columnValues.TodayCommitted",
        n: "Today Committed",
        t: "numericColumn",
        w: 141,
        c: "Order",
    },
    {
        f: "columnValues.TodayCommittedGlobal",
        n: "Today Committed (Global)",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.TodayFilledPct",
        n: "Today Filled %",
        t: "numericColumn",
        w: 122,
        c: "Fill Info",
    },
    {
        f: "columnValues.TodayFilledQty",
        n: "Today Filled Qty",
        t: "numericColumn",
        w: 132,
        c: "Fill Info",
    },
    {
        f: "columnValues.TodayFilledQtyGlobal",
        n: "Today Filled Qty (Global)",
        t: "numericColumn",
        c: "Fill Info",
    },
    {
        f: "columnValues.TodayFilledQtyPctNav",
        n: "Today Filled Qty as % NAV",
        t: "numericColumn",
        w: 186,
        c: "Fill Info",
    },
    {
        f: "columnValues.TradeReason",
        n: "Trade Reason",
        t: "standardColumn",
        w: 118,
        c: "Order",
    },
    {
        f: "columnValues.TradeSpread",
        n: "Trade Spread",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.Trader",
        n: "Trader",
        t: "standardColumn",
        w: 105,
        c: "Order",
    },
    {
        f: "columnValues.TraderDiscretion",
        n: "Trader Discretion",
        t: "standardColumn",
        c: "Order",
    },
    {
        f: "columnValues.TradingDesk",
        n: "Trading Desk",
        t: "standardColumn",
        w: 115,
        c: "Order",
    },
    {
        f: "columnValues.Txn",
        n: "Txn",
        t: "standardColumn",
        w: 97,
        c: "Order",
    },
    {
        f: "columnValues.Type",
        n: "Type",
        t: "standardColumn",
        w: 83,
        c: "Order",
    },
    {
        f: "columnValues.Underlier",
        n: "Underlier",
        t: "standardColumn",
        w: 96,
        c: "Security Master",
    },
    {
        f: "columnValues.UnderlyingAsk",
        n: "Underlying Ask",
        t: "standardColumn",
        c: "Related Market Data",
    },
    {
        f: "columnValues.UnderlyingBid",
        n: "Underlying Bid",
        t: "standardColumn",
        c: "Related Market Data",
    },
    {
        f: "columnValues.UnderlyingLast",
        n: "Underlying Last",
        t: "standardColumn",
        c: "Related Market Data",
    },
    {
        f: "columnValues.UnderlyingNotionalAmt",
        n: "Underlying Notional Amt",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.UndisclosedShort",
        n: "Undisclosed Short",
        t: "standardColumn",
        w: 143,
        c: "Order",
    },
    {
        f: "columnValues.UnFilledPct",
        n: "Unfilled %",
        t: "numericColumn",
        c: "Fill Info",
    },
    {
        f: "columnValues.UnfilledPctOf3M_ADV",
        n: "Unfilled % of 3M ADV",
        t: "numericColumn",
        w: 162,
        c: "Related Market Data",
    },
    {
        f: "columnValues.UnfilledPercentNAV",
        n: "Unfilled % of NAV",
        t: "numericColumn",
        c: "Order",
    },
    {
        f: "columnValues.UnfilledQty",
        n: "Unfilled Qty",
        t: "numericColumn",
        c: "Fill Info",
    },
    {
        f: "columnValues.VWAP",
        n: "VWAP",
        t: "numericColumn",
        w: 79,
        c: "Related Market Data",
    },
    {
        f: "columnValues.FilledPctOfVWAPShares",
        n: "VWAP %",
        t: "numericColumn",
        w: 92,
        c: "Related Market Data",
    },
    {
        f: "columnValues.VWAPShares",
        n: "VWAP Shares",
        t: "numericColumn",
        w: 118,
        c: "Related Market Data",
    },
    {
        f: "columnValues.VarianceUnits",
        n: "Variance Units",
        t: "numericColumn",
        c: "Related Market Data",
    },
    {
        f: "columnValues.Volume",
        n: "Volume",
        t: "numericColumn",
        w: 86,
        c: "Related Market Data",
    },
    {
        f: "columnValues.WorkflowState",
        n: "Workflow State",
        t: "standardColumn",
        w: 129,
        c: "Order",
    },
    {
        f: "columnValues.Working",
        n: "Working",
        t: "numericColumn",
        c: "Order",
    },
];
